





































































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../shared/services/mixin";
import {Component, Watch} from "vue-property-decorator";
import TooltipLabel from "../../../shared/components/TooltipLabel/TooltipLabel.vue";
import {LadingErrorCustomerParams} from "../params";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import {debounce} from "lodash";
import {LadingErrorCustomerStore} from "@/modules/ladingerrorcustomer/store";
import {LadingErrorStatus} from "@/enums/status/ladingerror";
import LadingErrorCustomerDetail from "@/modules/ladingerrorcustomer/Detail/index.vue";

const columns = [
    {
        title: "STT",
        dataIndex: "stt",
        key: "stt",
        width: 50,
        ellipsis: true
    },
    {
        title: "Thao tác",
        dataIndex: "id",
        key: "id",
        width: 80,
        scopedSlots: { customRender: 'action' },
        align: 'center'
    },
    {
        title: "Ngày, giờ sự cố",
        dataIndex: "createdDate",
        key: "createdDate",
        width: 150,
        ellipsis: true
    },
    {
        title: "Mã đơn hàng",
        dataIndex: "billLading.ladingCode",
        key: "ladingCode",
        width: 150,
        ellipsis: true,
        scopedSlots: { customRender: 'ladingCode' }
    },
    {
        title: "Sự cố",
        dataIndex: "note",
        key: "note",
        width: 200,
        ellipsis: true,
        scopedSlots: { customRender: 'note' }
    },
    {
        title: "Hướng dẫn xử lý",
        dataIndex: "customerResponse",
        key: "customerResponse",
        width: 200,
        ellipsis: true,
        scopedSlots: { customRender: 'customerResponse' }
    },
    // {
    //     title: "Người nhận",
    //     dataIndex: "billLading.locationTo",
    //     key: "locationToName",
    //     width: 150,
    //     ellipsis: true,
    //     scopedSlots: { customRender: 'locationToName' }
    // },
    // {
    //     title: "SDT Người nhận",
    //     dataIndex: "billLading.locationTo",
    //     key: "locationToPhoneNumber",
    //     width: 150,
    //     ellipsis: true,
    //     scopedSlots: { customRender: 'locationToPhoneNumber' }
    // },
    // {
    //     title: "Địa chỉ",
    //     dataIndex: "billLading.locationTo",
    //     key: "locationToAddress",
    //     width: 500,
    //     ellipsis: true,
    //     scopedSlots: { customRender: 'locationToAddress' }
    // },
    // {
    //     title: "Hàng hóa",
    //     dataIndex: "billLading.boxContent",
    //     key: "boxContent",
    //     width: 150,
    //     ellipsis: true,
    //     scopedSlots: { customRender: 'boxContent' }
    // },
    {
        title: "Trạng thái",
        dataIndex: "status",
        key: "status",
        width: 120,
        ellipsis: true,
        scopedSlots: { customRender: 'status' }
    }
];
@Component({
    name: "LadingErrorCustomerList",
    components: {LadingErrorCustomerDetail, TooltipLabel}
})
export default class extends mixins(CommonMixin) {
    LadingErrorStatus = LadingErrorStatus;
    params = new LadingErrorCustomerParams();
    columns = [...columns];
    selectedId: number = null as any;
    visibleDetail = false;

    get ladingErrorCustomers() {
        return LadingErrorCustomerStore.ids.map((id: number) => LadingErrorCustomerStore.data[id]);
    }

    created() {
        LadingErrorCustomerStore.updateLadingErrorCustomerParams(new LadingErrorCustomerParams());
        this.listLadingErrorCustomer(LadingErrorCustomerStore.params);
    }

    async listLadingErrorCustomer(params: any) {
        try {
            await LadingErrorCustomerStore.listLadingErrorCustomer(params);
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Đã xảy ra lỗi");
        }
    }

    get pagination() {
        return {
            current: LadingErrorCustomerStore.meta.page,
            pageSize: LadingErrorCustomerStore.meta.limit,
            total: LadingErrorCustomerStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} đơn sự cố`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
        LadingErrorCustomerStore.updateLadingErrorCustomerParams({...LadingErrorCustomerStore.params, page: pagination.current, limit: pagination.pageSize});
        this.listLadingErrorCustomer(LadingErrorCustomerStore.params);
    }

    @Watch("params", { deep: true })
    onChangeParams(val: any) {
        this.handleChangeParams(val, this);
    }

    handleChangeParams = debounce((val: any, vm) => {
        LadingErrorCustomerStore.updateLadingErrorCustomerParams({...val, page: 1});
        vm.listLadingErrorCustomer(LadingErrorCustomerStore.params);
    }, 500)
}
